module.exports = __webpack_public_path__ + "static/media/integrations-module-bamboo.d5a1bbc4.svg";